import React from "react";
import PropTypes from "prop-types";
//
import { Col, Card } from "react-bootstrap";
//
import OuterLink from "../general/OuterLink";
import Moment from "react-moment";

function NewsItem({ item }) {
  return (
    <Col sm={6} md={6} xxl={4} className="news-item gutter-b">
      {/* <Card
        style={{ backgroundImage: `url(${item.image})` }}
        className="news-holder"
      ></Card> */}

      <Card className="info">
        <div className="date-img">
          <div className="date">
            NEWS
            <span></span>
            <Moment utc unix format="MMMM DD, YYYY">
              {+item.published}
            </Moment>
          </div>

          <div className="img">
            {/* <img src={item.image} alt="author image" /> */}
            <span className="truncate">{item.author}</span>
          </div>
        </div>

        <h5>{item.title}</h5>

        <OuterLink text="See Article" link={item.link} />
      </Card>
    </Col>
  );
}

NewsItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default NewsItem;
